import { getInstance }     from 'StateManager';
import { replaceMacros }   from 'Misc/format';
import { expiringRequest } from 'Misc/timing';

export default class Reporter {
  constructor(resource, whitelisted = false) {
    this.resource      = resource;
    this.whitelisted   = whitelisted;
    this.rootContainer = getInstance().state.display.container;
    this.onLoad  = this.onEnd.bind(this, 'load');
    this.onError = this.onEnd.bind(this, 'error');
  }

  run() {}

  inject(element) {
    this.expirer = expiringRequest(this.resource);

    element.addEventListener('load',  this.onLoad);
    element.addEventListener('error', this.onError);

    this.requestElement = element;
    this.rootContainer.appendChild(element);
  }

  onEnd(cause, event) {
    if(this.requestElement) {
      this.rootContainer.removeChild(this.requestElement);
      this.requestElement.removeEventListener('load', this.onLoad);
      this.requestElement.removeEventListener('error', this.onError);
    }

    if(this.expirer) {
      switch(cause) {
        case 'load':
          this.expirer.resolve(event);
          break;
        case 'error':
          this.expirer.reject(event);
          break;
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/Services/Reporting/Reporter.js